import * as _ from 'lodash';

export const MapToStartCase = (value: string): string => {
  return _.startCase(_.toLower(value));
};
export const Last4Chars = (text: string): string => {
  if (!text || text.length < 4) {
    return '';
  }
  return text.substring(text.length - 4);
};
